//# sourceMappingURL=my-default-month.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-mydatepicker/dist/interfaces/my-default-month.interface.js
// module id = 569
// module chunks = 10